import { makeGetHasTestFlag } from 'ContentEditorUI/redux/selectors/testFlagSelectors';
export const DISABLE_CUSTOM_JITA_UI = 'disableCustomJitaUI';
export const getDisableCustomJitaUI = makeGetHasTestFlag(DISABLE_CUSTOM_JITA_UI);